import { HttpClient } from '@/shared/lib/http-client';

export const fetchUserAccountBalance = async () => {
  const response = await HttpClient.post('/transactions/all', {});
  return response.data;
};
